import { render, staticRenderFns } from "./NotesDialog.vue?vue&type=template&id=0acf8f80&scoped=true&"
import script from "./NotesDialog.vue?vue&type=script&lang=js&"
export * from "./NotesDialog.vue?vue&type=script&lang=js&"
import style0 from "./NotesDialog.vue?vue&type=style&index=0&id=0acf8f80&prod&lang=scss&scoped=true&"
import style1 from "./NotesDialog.vue?vue&type=style&index=1&id=0acf8f80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf8f80",
  null
  
)

export default component.exports